import { createFileRoute, redirect } from '@tanstack/react-router';
import { useAlert } from '@frontend/design-system';
import { Login as LoginComponent } from '../../../pages';
import { useIntegrationsDashboardShallowStore } from '../../../store';
import { checkIsUserAuthenticated } from '../../../utils/helpers';

const SignIn = () => {
  const alert = useAlert();
  const { auth } = Route.useRouteContext();
  const { isUserLoggingIn, setIsUserLoggingIn } = useIntegrationsDashboardShallowStore(
    'isUserLoggingIn',
    'setIsUserLoggingIn'
  );

  const handleLogin = async () => {
    try {
      setIsUserLoggingIn(true);
      await auth.signIn();
    } catch (err) {
      console.error('Error during sign-in:', err);
      alert.error({ message: 'There was an error during sign-in. Please try again.', autoDismissAfter: 2000 });
    }
  };

  return <LoginComponent onLoginButtonClick={handleLogin} isLoginButtonLoading={isUserLoggingIn} />;
};

export const Route = createFileRoute('/_public/sign-in')({
  component: SignIn,
  beforeLoad: () => {
    if (checkIsUserAuthenticated()) {
      return redirect({
        to: '/dashboard',
      });
    }
    return false;
  },
});
